import { History } from 'history';

import { canGoBackInApp } from './navigationDepth';
import { getHomeRoute } from './getHomeRoute';

export const goBackOrHome = (history: History) => {
  if (canGoBackInApp()) {
    history.goBack();
    return;
  }

  history.replace(getHomeRoute(history.location.pathname));
};
